<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <clipPath id="zuzkpwsmqa">
        <path
          data-name="사각형 286391"
          style="fill: none"
          d="M0 0h21.859v16H0z"
        />
      </clipPath>
    </defs>
    <path data-name="사각형 286392" style="fill: none" d="M0 0h24v24H0z" />
    <g data-name="그룹 16277">
      <g
        data-name="그룹 16276"
        style="clip-path: url(#zuzkpwsmqa)"
        transform="translate(1.141 4)"
      >
        <path
          data-name="패스 87272"
          d="M17.859 16v-3a4.031 4.031 0 0 0-.612-2.113 5.406 5.406 0 0 0-1.738-1.737 12.591 12.591 0 0 1 2.4.513 12.456 12.456 0 0 1 2.1.887 4.421 4.421 0 0 1 1.375 1.113A2.132 2.132 0 0 1 21.859 13v3z"
          style="fill: #087ef7"
        />
        <path
          data-name="패스 87273"
          d="M17.859 4a3.852 3.852 0 0 1-1.175 2.825A3.852 3.852 0 0 1 13.859 8a5.085 5.085 0 0 1-.7-.062 6.181 6.181 0 0 1-.7-.138A5.951 5.951 0 0 0 13.5 6.025a5.845 5.845 0 0 0 0-4.05A5.951 5.951 0 0 0 12.459.2a3 3 0 0 1 .7-.162 6.315 6.315 0 0 1 .7-.038 3.852 3.852 0 0 1 2.825 1.175A3.852 3.852 0 0 1 17.859 4"
          style="fill: #087ef7"
        />
        <path
          data-name="패스 87274"
          d="M0 16v-2.8a2.978 2.978 0 0 1 1.6-2.65 14.853 14.853 0 0 1 3.15-1.163 13.84 13.84 0 0 1 6.5 0 14.853 14.853 0 0 1 3.15 1.163A2.978 2.978 0 0 1 16 13.2V16z"
          style="fill: #ffc304"
        />
        <path
          data-name="패스 87275"
          d="M8 8a3.852 3.852 0 0 1-2.825-1.175A3.852 3.852 0 0 1 4 4a3.852 3.852 0 0 1 1.175-2.825A3.852 3.852 0 0 1 8 0a3.852 3.852 0 0 1 2.825 1.175A3.852 3.852 0 0 1 12 4a3.852 3.852 0 0 1-1.175 2.825A3.852 3.852 0 0 1 8 8"
          style="fill: #ffc304"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
